/** Paid desk plans shared by Journey checkout and the PayPal gateway.
 * QVQ+ BMP / bundle SKUs live in the BMP repo (`src/lib/qvq/plans.ts`).
 */
import { billingSkus } from "./catalog.js";

export const PAID_PLANS = billingSkus();

export function resolvePaidPlan({ plan = "agent", tier = "", cycle = "monthly" } = {}) {
  const raw = String(plan || "agent").toLowerCase();
  const billCycle = String(cycle || "monthly").toLowerCase() === "annual" ? "annual" : "monthly";

  let base;
  if (raw === "corporate" || raw === "enterprise") {
    base = PAID_PLANS.find((row) => row.id === "corporate") || PAID_PLANS[0];
  } else if (raw === "broker") {
    base =
      PAID_PLANS.find((row) => row.sku === "broker" && row.tier === String(tier || "10")) ||
      PAID_PLANS.find((row) => row.id === "broker_10");
  } else {
    base = PAID_PLANS.find((row) => row.id === "agent_monthly") || PAID_PLANS[0];
  }

  if (!base) return null;

  const isAnnual = billCycle === "annual" && base.amountAnnual;
  return {
    ...base,
    amount: isAnnual ? base.amountAnnual : base.amount,
    cycle: isAnnual ? "annual" : "monthly",
    interval: isAnnual ? "year" : "month",
  };
}

export function formatPlanPrice(plan) {
  if (!plan) return "";
  const interval = plan.interval || (plan.cycle === "annual" ? "year" : "month");
  return `$${plan.amount} / ${interval}`;
}
